export const SAVED = 'saved';
export const CLICKED_PLAY = 'clickedPlay';
export const CLICKED_PAUSE = 'clickedPause';
export const CLICKED_RESET = 'clickedReset';
export const CLICKED_FORWARD = 'clickedForward';
export const CLICKED_REWIND = 'clickedRewind';
export const TOGGLED_SPECTRUM = 'toggledSpectrum';
export const TOGGLED_ELECTRIC_FIELD_VECTORS_ON =
  'toggledElectricFieldVectorsOn';
export const TOGGLED_ELECTRIC_FIELD_VECTORS_OFF =
  'toggledElectricFieldVectorsOff';
export const TOGGLED_CHARGE_SIGNS_ON = 'toggledChargeSignsOn';
export const TOGGLED_CHARGE_SIGNS_OFF = 'toggledChargeSignsOff';
export const TOGGLED_RE_EMISSION_ON = 'toggledReEmissionOn';
export const TOGGLED_RE_EMISSION_OFF = 'toggledReEmissionOff';
